<script>
import axios from 'axios'
import moment from 'moment/moment'
const _ = require('lodash')
export default {
  name: 'ExecutionTasks',
  computed: {
    moment() {
      return moment
    }
  },

  props: {
    execution: {
      type: Object,
      required: true
    }
  },
  watch: {
    pagination: {
      handler() {
        try {
          if (
            this.pagination.page !== this.current.page ||
            this.pagination.rowsPerPage !== this.current.rowsPerPage ||
            this.pagination.sortBy !== this.current.sortBy ||
            this.pagination.descending !== this.current.descending
          ) {
            this.current.page = this.pagination.page
            this.current.rowsPerPage = this.pagination.rowsPerPage
            this.current.sortBy = this.pagination.sortBy
            this.current.descending = this.pagination.descending
            this.getItems()
          }
          // eslint-disable-next-line no-empty
        } catch (error) {}
      },
      deep: true
    }
  },
  data: () => ({
    headerUserTasks: [
      {
        text: 'Task Name / Task Id',
        align: 'left',
        value: 'name',
        sortable: false
      },
      { text: 'Status', value: 'status' },
      { text: 'Created At', value: 'createdAt' },
      { text: 'Due date', value: 'due' },
      { text: 'Assignee', value: 'assignee' },
      { text: 'Group Users', value: 'candidateEmailList', sortable: false },
      { text: 'Task Type', value: 'taskType' }
    ],
    userTasks: [],
    userTasksLoading: false,
    searchUserTasks: '',
    pagination: {
      page: 1,
      rowsPerPage: 5,
      sortBy: 'createdAt',
      descending: false,
      totalItems: 0
    },
    current: {
      page: 1,
      rowsPerPage: 5,
      sortBy: 'createdAt',
      descending: false
    },
    rowsPerPageItems: [5, 10, 25]
  }),

  mounted() {
    this.getItems()
  },
  methods: {
    format(input) {
      return _.capitalize(_.startCase(input))
    },
    getUrlParams() {
      let urlParams = ''
      //fill URL Params from current structure

      urlParams += `&page=${this.current.page}`
      urlParams += `&size=${this.current.rowsPerPage}`
      if (this.current.sortBy) {
        urlParams += `&sort=${this.current.sortBy}`
        if (this.current.descending) {
          urlParams += `,desc`
        }
      }
      if (this.searchUserTasks) {
        urlParams += `&taskId=${this.searchUserTasks}`
      }
      return urlParams
    },
    getItems() {
      this.userTasksLoading = true
      const urlParams = this.getUrlParams()
      axios
        .get(`/api/v1/userTasks/execution/${this.execution.hexId}?${urlParams}`)
        .then(response => {
          if (response.data._embedded) {
            this.pagination.totalItems = response.data.page.totalElements
            this.userTasks = response.data._embedded.userTasks
            this.userTasksLoading = false
          } else {
            this.pagination.totalItems = 0
            this.userTasks = []
            this.userTasksLoading = false
          }
        })
        .catch(error => {
          console.log(error)
          this.userTasksLoading = false
        })
    }
  }
}
</script>

<template>
  <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
    <v-card-title>
      <span class="body-1 beez-bold pl-3"
        >Tasks created as part of this workflow execution
      </span>
      <v-spacer />
      <v-list-tile-avatar>
        <v-icon>search</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          <v-text-field
            v-model="searchUserTasks"
            color="secondary"
            label="Search task by Task Id"
            xs5
          >
          </v-text-field>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="searchUserTasks = ''">
          <v-icon>clear</v-icon>
        </v-btn>
        <span>Clear search</span>
      </v-tooltip>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="getItems()">
          <v-icon>cached</v-icon>
        </v-btn>
        <span>Refresh</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headerUserTasks"
        :items="userTasks"
        :loading="userTasksLoading"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
        :total-items="pagination.totalItems"
        item-key="hexId"
      >
        <v-progress-linear slot="progress" color="accent" indeterminate />
        <template slot="items" slot-scope="props">
          <tr>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div class="body-2 font-weight-bold orange--text">
                {{ props.item.formKey }}
              </div>
              <div class="caption">
                {{ props.item.taskId }}
              </div>
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div class=" body-1 font-weight-bold">
                <span
                  v-if="props.item.status === 'assignment'"
                  style="font-weight: 500"
                  class="pr-2"
                  >Assigned</span
                >
                <span
                  v-else-if="props.item.status === 'create'"
                  style="font-weight: 500"
                  class="pr-2"
                  >Open</span
                >
                <span
                  v-else-if="props.item.status === 'delete'"
                  style="font-weight: 500"
                  class="pr-2"
                  >Deleted</span
                >
                <span
                  v-else-if="props.item.status === 'complete'"
                  style="font-weight: 500"
                  class="pr-2"
                  >Completed</span
                >
                <span v-else style="font-weight: 500" class="pr-2">{{
                  format(props.item.status)
                }}</span>
              </div>
            </td>

            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{
                props.item.createdAt
                  ? moment(props.item.createdAt)
                      .utc()
                      .local()
                      .format('DD MMM YYYY hh:mm:ss a')
                  : ''
              }}
            </td>

            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              {{
                props.item.due
                  ? moment(props.item.due)
                      .utc()
                      .local()
                      .format('DD MMM YYYY hh:mm:ss a')
                  : ''
              }}
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div class=" body-1 font-weight-bold">
                {{ props.item.assignee }}
              </div>
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div class=" body-1 font-weight-bold">
                {{ props.item.candidateEmailList.join(', ') }}
              </div>
            </td>
            <td class="text-xs-left" @click="props.expanded = !props.expanded">
              <div class=" body-1 font-weight-bold">
                {{ format(props.item.taskType) }}
              </div>
            </td>
          </tr>
        </template>
        <template slot="expand" slot-scope="props">
          <v-flex class="pa-2">
            <v-card flat :class="$vuetify.dark ? 'card-dark' : 'card-light'">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex v-if="props.item.dimension1">
                    <div>
                      <br />
                      <div class="beez-bold">
                        {{ props.item.dimension1 }}
                      </div>
                      <div class="subheading">
                        {{ props.item.value1 }}
                      </div>
                      <br />
                    </div>
                  </v-flex>
                  <v-flex v-if="props.item.dimension2">
                    <div>
                      <br />
                      <div class="beez-bold">
                        {{ props.item.dimension2 }}
                      </div>
                      <div class="subheading">
                        {{ props.item.value2 }}
                      </div>
                      <br />
                    </div>
                  </v-flex>
                  <v-flex v-if="props.item.dimension3">
                    <div>
                      <br />
                      <div class="beez-bold">
                        {{ props.item.dimension3 }}
                      </div>
                      <div class="subheading">
                        {{ props.item.value3 }}
                      </div>
                      <br />
                    </div>
                  </v-flex>
                  <v-flex v-if="props.item.dimension4">
                    <div>
                      <br />
                      <div class="beez-bold">
                        {{ props.item.dimension4 }}
                      </div>
                      <div class="subheading">
                        {{ props.item.value4 }}
                      </div>
                      <br />
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </template>
        <template slot="no-data">
          <v-alert :value="true" color="warning" icon="warning">
            No Tasks created!
          </v-alert>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<style scoped></style>
